import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { API_URL } from '@constants/api.constant';
import { environment } from '@environments/environment';
import { BYPASS_LOG } from '@constants/app.constant';
import { LoginResponseModel } from '@models/auth.models';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs';
import { AppRoutes } from '@constants/app.route';

export const authGuard: CanActivateFn = (route, segments) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	const http = inject(HttpClient);
	if (!authService.isRefreshTokenValid()) {
		return of(router.parseUrl(`/${AppRoutes.AUTH}`));
	}


	// Se non c'è il token, redirect immediato
	if (!authService.getToken()) {
		return of(router.parseUrl(`/${AppRoutes.AUTH}`));
		
	}

	// Se il token è ancora valido, permetti l'accesso
	if (authService.isLoggedIn()) {
		return of(true);
	}

	// Token scaduto → tenta il refresh
	
	const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
	const context = new HttpContext().set(BYPASS_LOG, true);

	let refreshToken = localStorage.getItem('@aion_refreshToken');
	return http.post<LoginResponseModel>(API_URL.getRefreshToken, JSON.stringify(refreshToken), { headers, context }).pipe(
		map(res => {
			authService.setToken(res);
			return true;
		}),
		catchError(err => {
			authService.deleteToken();
			return of(router.parseUrl(`/${AppRoutes.AUTH}`));
		})
	);
};
